<template>
  <div class="user-statement">
    <section>
      <h2>高绩统一登录平台用户声明</h2>
      <p>欢迎使用高绩统一用户登录平台（以下统称“高绩平台”），高绩平台是由上海高绩数据科技有限公司（以下简称“我们”）提供的信息技术服务产品。请您使用高绩平台前，仔细阅读以下条款，如您开始使用或接受任何高绩服务的，即视为您已阅读并与高绩达成协议，自愿接受本协议全部条款、规则及内容的约束。您在开始使用高绩平台之前务必审慎阅读、充分理解各条款内容，对于本协议中以加粗字体显示的内容，您应重点阅读。如您对本协议有任何疑问的，应向高绩咨询。高绩可能会更新协议内容，您在使用高绩提供的各项服务之前，应仔细阅读本服务协议。如果您不同意本协议的约定，应立即停止使用高绩平台。</p>
    </section>
    <section>
      <h3>一、	总则</h3>
      <p>1. 高绩平台是一个高等教育数据汇聚与分析平台，为您提供客观、快速、便捷的大学、学科、专业、院系等信息查询服务。通过数据挖掘、清洗、分析、聚合、建模等为高等学校、政府部门、第三方评价机构提供分析参考。还为您逐步提供优质指标推荐、收藏、分享等增值服务。</p>
      <p>2. 高绩平台所有权、经营权、管理权均属上海高绩数据科技有限公司。</p>
      <p>3. 高绩平台有权随时根据中华人民共和国有关法律、法规的变化、互联网的发展以及公司经营状况和经营策略的调整等情况调整产品规则及本协议的内容。您同意政策、通知等事项自发布之日起生效，您将自行及时查阅相关通知，并按照通知及变更后的产品政策及修订后的协议修订履行相关义务，如果您不同意变更事项应当于公示3日内以书面形式向高绩申请终止本协议，您继续使用变更后的服务视为接受变更内容。如发生协议条款与中华人民共和国法律相抵触时，则这些条款将完全按法律规定重新解释，其它条款则依旧保持对客户产生法律效力和影响。</p>
    </section>
    <section>
      <h3>二、	高绩平台用户</h3>
      <p>1. 凡是购买或使用过高绩产品的用户均为高绩平台用户（以下统称“您”）。针对您提供的注册资料，您同意并保证：</p>
      <ul>
        <li>1.1 提供合法、真实、准确、详尽的个人资料；</li>
        <li>1.2 如有变动，及时更新您资料。如果您提供的注册资料中存在不合法、不真实、不准确、不详尽的，您须承担因此引起的相应责任及后果，并且高绩保留随时终止您使用高绩平台各项服务的权利；</li>
        <li>1.3 高绩平台的用户名和昵称中不能含有任何侮辱、威胁、淫秽、谩骂等侵害他人合法权益的文字；</li>
        <li>1.4 若因输入的个人信息不真实而引发的一切问题、纠纷及所带来的后果，由您个人独立承担，高绩不负任何责任。</li>
      </ul>
      <p>2. 高绩非常重视您的隐私保护和个人信息保护，我们将依照本协议及《高绩隐私政策》的规定收集、使用、储存和分享您的个人信息。</p>
    </section>
    <section>
      <h3>三、	用户权利和义务</h3>
      <p>1. 您享有言论自由的权利。</p>
      <p>2. 您的言行不得违反《计算机信息网络国际联网安全保护管理办法》、《互联网信息服务管理办法》、《互联网电子公告服务管理规定》、《维护互联网安全的决定》、《互联网新闻信息服务管理规定》、《最高人民法院、最高人民检察院关于办理利用信息网络实施诽谤等刑事案件适用法律若干问题的解释》等相关法律规定，不得在高绩统一用户登录平台发布、传播或以其它方式传送含有下列内容之一的信息：</p>
      <ul>
        <li>2.1 反对宪法所确定的基本原则的；</li>
        <li>2.2 危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；</li>
        <li>2.3 损害国家荣誉和利益的；</li>
        <li>2.4 煽动民族仇恨、民族歧视、破坏民族团结的；</li>
        <li>2.5 破坏国家宗教政策，宣扬邪教和封建迷信的；</li>
        <li>2.6 散布谣言，扰乱社会秩序，破坏社会稳定的；</li>
        <li>2.7 散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；</li>
        <li>2.8 侮辱或者诽谤他人，侵害他人合法权利的；</li>
        <li>2.9 煽动非法集会、结社、游行、示威、聚众扰乱社会秩序的；</li>
        <li>2.10 以非法民间组织名义活动的；</li>
        <li>2.11 含有虚假、有害、胁迫、侵害他人隐私、骚扰、侵害、中伤、粗俗、猥亵、或其它道德上令人反感的内容；</li>
        <li>2.12 含有中国法律、法规、规章、条例以及任何具有法律效力之规范所限制或禁止的其它内容的。</li>
      </ul>
    </section>
    <section>
      <h3>四、	权利声明和免责声明</h3>
      <ul>
        <li>1. 高绩平台是为您提供客观、快速、便捷的高等教育信息查询和分析服务平台。高绩平台的所有数据均来源于教育部网站（http://www.moe.gov.cn/）、科技部网站（http://www.most.gov.cn/）等政府相关部门及互联网络公开公示信息，以及通过合法授权获得的信息。高绩自身不控制、不修改数据的具体内容或表现形式，仅对从各个渠道获取的信息如实展示。高绩对于这些数据的真实性、完整性和时效性，不作任何形式的保证和承担任何责任。同时，高绩对于上述数据综合分析而得出的任何形式的相应结论，仅为您的决策提供参考，因使用分析而产生的任何后果，高绩不承担任何责任。高绩对由于您使用本网站服务、或依据本网站信息进行任何形式的活动引起的对任何第三方的损害不承担任何赔偿责任。</li>
        <li>2. 高绩平台的内容及提供的服务不含任何明示性或暗示性的声明、保证或条件，包括但不限于关于信息的真实性、完整性和时效性或适用于某一特定用途的明示或暗示性的声明、保证或条件。您使用提供的数据或服务时，即表示明确同意其使用本网站数据或服务所存在的风险及一切后果将完全由其自己承担。</li>
        <li>3. 由于政府禁令、现行生效的适用法律或法规的变更、火灾、地震、瘟疫、战争、停电、通讯线路中断、电信部门技术调整、因政府管制而造成网站的暂时性关闭等其他任何影响网络正常运营的不可预见、不可避免、不可克服和不可控制的事件（“不可抗力事件”）；以及他人蓄意破坏，黑客攻击、计算机病毒，系统维护、系统升级，网络过载等技术问题（“技术事件”）而导致高绩平台能访问而造成的平台所提供的信息及数据的延误、停滞或错误，高绩无须承担责任。</li>
        <li>4. 您与其他用户之间因使用高绩平台而产生或可能产生的任何纠纷或损失，由您自行解决并承担相应的责任，与高绩无关。</li>
        <li>5. 任何由于因网络状况、通讯线路、第三方网站等不可抗力导致您不能正常使用高绩平台的，高绩不承担法律责任。</li>
        <li>6. 高绩平台如因系统维护或升级等而需暂停服务时，将事先公告。若因硬件故障或其它不可抗力而导致暂停服务，于暂停服务期间造成的一切不便与损失，高绩不负任何责任。由于高绩平台的调整导致信息丢失或其他结果的，高绩不承担任何责任。</li>
        <li>7. 任何通过使用高绩平台而链接到的第三方网页均系他人制作或提供，您可能从该第三方网页上获得资讯及享用服务，高绩对其合法性概不负责，亦不承担任何法律责任。</li>
        <li>8. 除高绩平台注明之服务条款外，其他一切因使用高绩平台而可能遭致的意外、疏忽、侵权及其造成的损失（包括因下载被搜索链接到的第三方网站内容而感染电脑病毒），高绩对其概不负责，亦不承担任何法律责任。</li>
        <li>9. 任何单位或个人认为通过高绩平台链接到的第三方网页内容可能涉嫌侵犯其信息网络传播权或其他权利，应该及时向高绩提出书面权利通知，并提供身份证明、权属证明及详细侵权情况证明。高绩在收到上述法律文件后，将会依法尽快断开相关链接内容。</li>
      </ul>
    </section>
    <section>
      <h3>五、	权利声明</h3>
      <p>任何个人或单位如果同时符合以下两个条件：</p>
      <ul>
        <li>1.	权利人发现网络用户利用网络服务侵害其合法权益或高绩统一用户登录平台所展示内容侵犯其合法权益；</li>
        <li>2. 权利人与该信息发布单位沟通并取得信息发布方书面更正文件，但高绩平台所展示内容通过手动刷新或自信息发布单位更正之日起三日后高绩平台中的内容仍未更新的。</li>
      </ul>
      <p>请上述个人或单位务必以书面的通讯方式向高绩提交权利通知。</p>
      <p>请注意：如果权利通知的陈述失实，权利通知提交者将承担对由此造成的全部法律责任（包括但不限于赔偿各种费用及律师费）。如果上述个人或单位不确定网络上可获取的资料是否侵犯了其合法权益，高绩建议该个人或单位首先咨询专业人士。</p>
      <p>为了高绩有效处理上述个人或单位的权利通知，请使用以下格式（包括各条款的序号）：</p>
      <ol>
        <li>1. 权利人对涉嫌侵权内容拥有商标权、著作权和/或其他依法可以行使权利的权属证明。</li>
        <li>2. 请充分、明确地描述确信被侵犯了权利人合法权益的内容。</li>
        <li>3. 请指明涉嫌侵权网页的哪些内容侵犯了第2项中列明的权利人的合法权益。</li>
        <li>4. 请提供权利人具体的联络信息，包括姓名、身份证或护照复印件（对自然人）、单位登记证明复印件（对单位）、通信地址、电话号码、传真和电子邮件。</li>
        <li>5. 请在权利通知中加入如下关于通知内容真实性的声明：</li>
        <li>5.1 “我本人为所投诉内容的合法权利人；</li>
        <li>5.2 在我举报的网页上登载的内容侵犯了本人相应的合法权益；</li>
        <li>5.3 本人确认：如果本权利通知内容不完全属实，本人将承担由此产生的一切法律责任。</li>
        <li>6. 请在权利通知中加入以下陈述：“我保证，本通知中所述信息是充分、真实、准确的，我是所投诉内容的合法权利人，或，我已获授权，有权行使第2项中列明内容的权益。”</li>
        <li>7. 请您签署该文件，如果您是依法成立的机构或组织，请您加盖公章。</li>
      </ol>
      <p>请您把以上资料和联络方式书面通过邮件方式通知高绩：</p>
      <p>邮件地址：support@gaojidata.com</p>
    </section>
    <section>
      <h3>六、	版本声明</h3>
      <ul>
        <li>1、除非高绩另行声明，高绩平台内的所有产品、技术、软件、程序、数据及其他信息（包括但不限于文字、图像、图片、照片、音频、视频、图表、色彩、版面设计、电子文档）的所有权利所有知识产权（包括但不限于版权、商标权、专利权、商业秘密及其他所有相关权利）均归高绩所有。未经高绩许可，任何人不得擅自使用（包括但不限于通过任何机器人、蜘蛛等程序或设备监视、复制、传播、展示、镜像、上载、下载）高绩平台内的任何内容。</li>
        <li>2、高绩尊重知识产权，反对侵权盗版行为。未经高绩许可，任何人不得擅自（包括但不限于：以非法的方式复制、传播、展示、镜像、上载、下载）使用，或通过非常规方式（如：恶意干预高绩平台数据）影响高绩平台的正常服务，任何人不得擅自以软件程序自动获得高绩平台数据。否则，高绩有权依法追究其法律责任。</li>
        <li>3、未经高绩许可，任何人禁止转载或商业使用高绩平台内文字、图形、表格等信息，否则，高绩保留采取一切合法方式维护正当利益的权利。经许可的信息的转载或商业使用时，应当以恰当方式说明，该信息来源于高绩。</li>
      </ul>
    </section>
    <section>
      <h3>七、	附则</h3>
      <p>1.适用法律和管辖</p>
      <ul>
        <li>1.1 因您使用高绩平台而引起或与之相关的一切争议、权利主张或其它事项，均受中华人民共和国法律的管辖；</li>
        <li>1.2 您和高绩发生争议的，应首先本着诚信原则通过协商加以解决。如果协商不成，则应向上海市闵行区人民法院或其上一级人民法院提起诉讼。</li>
      </ul>
    </section>
  </div>
</template>

<script>
export default {
  name: 'user_statement',
  data() {
    return {

    }
  }
}
</script>
<style lang="scss">
.user-statement {
  text-align: left;
  font-size: 14px;
  color: #343438;
  word-break: break-all;
	section{
    font-size: 14px;
    line-height: 22px;
    color: #343438;
		margin-bottom: 54px;
		h2 {
			height: 32px;
			line-height: 32px;
			margin: 9px 0;
			font-size: 20px;
			color: #434345;
			margin-bottom: 8px;
		}
		h3{
			font-size: 16px;
			height: 16px;
			line-height: 16px;
			margin-bottom: 18px;
		}
		h5{
			font-size: 14px;
			font-weight: 600;
			margin-bottom: 14px;
		}
		p{
			margin-bottom: 14px;
		}
		div{
			margin-bottom: 14px;
		}
		li{
			margin-bottom: 14px;
			span{
				display: inline-block;
				margin-right: 12px;
			}
		}
	}
}
</style>
